import { TRUST_BADGE_INNER_HTML } from "../../shared/seo/trustBadge";

/**
 * The verified-puzzle promise under the page heading. The inner markup comes from
 * the shared module — the same string the static document is written with — so the
 * client and the pre-rendered page can never disagree about it. It is a constant
 * defined in this repository, not page content, so injecting it wholesale is safe.
 */
export function TrustBadge() {
  return <p className="trust-badge" dangerouslySetInnerHTML={{ __html: TRUST_BADGE_INNER_HTML }} />;
}
